import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reveal-password"
export default class extends Controller {
  static targets = ["input", "icon", "button"]
  static values = {
    showLabel: String,
    hideLabel: String,
  }

  declare inputTarget: HTMLInputElement
  declare iconTarget: HTMLElement
  declare buttonTarget: HTMLButtonElement
  declare showLabelValue: string
  declare hideLabelValue: string

  toggle() {
    const wasRevealed = this.inputTarget.type === "text"
    const isRevealed = !wasRevealed

    this.inputTarget.type = isRevealed ? "text" : "password"
    this.iconTarget.classList.toggle("fa-eye", wasRevealed)
    this.iconTarget.classList.toggle("fa-eye-slash", isRevealed)
    this.buttonTarget.setAttribute("aria-label", isRevealed ? this.hideLabelValue : this.showLabelValue)
  }
}
